// Mock data for TK Melati Asri

export const nav = [
  { id: 'tentang', label: 'Tentang Kami' },
  { id: 'program', label: 'Program' },
  { id: 'galeri', label: 'Galeri' },
  { id: 'guru', label: 'Guru Kami' },
  { id: 'berita', label: 'Berita' },
];

export const programs = [
  {
    id: 'kb',
    title: 'Kelompok Bermain',
    subtitle: 'Play Group',
    age: 'Usia 2 - 3 Tahun',
    desc: 'Belajar sambil bermain untuk mengenal warna, suara, dan teman baru dalam suasana hangat.',
    tags: ['#Bermain', '#Motorik', '#Sosial'],
    color: 'peach',
    tagline: 'Langkah pertama menuju petualangan besar!',
    duration: '2 jam / hari',
    days: 'Senin - Kamis',
    ratio: '1 guru : 6 anak',
    price: 'Rp 450.000 / bulan',
    goals: [
      'Mengenal warna, bentuk dan suara di sekitarnya',
      'Melatih motorik halus & kasar dengan permainan sederhana',
      'Membangun rasa percaya diri dan berani berpisah sementara dengan orang tua',
      'Belajar bermain bersama dan berbagi mainan',
    ],
    subjects: [
      { icon: 'Palette', name: 'Sensory Play', desc: 'Meraba pasir, air, playdough & tekstur.' },
      { icon: 'Music', name: 'Bernyanyi & Menari', desc: 'Lagu ceria & gerak tubuh.' },
      { icon: 'Puzzle', name: 'Bermain Bebas', desc: 'Balok, mainan susun & imajinasi.' },
      { icon: 'Smile', name: 'Cerita Sederhana', desc: 'Buku bergambar besar.' },
    ],
    schedule: [
      { time: '08.00', activity: 'Datang & bermain bebas' },
      { time: '08.30', activity: 'Circle Time - Salam & lagu pembuka' },
      { time: '09.00', activity: 'Sensory play / kegiatan tema' },
      { time: '09.30', activity: 'Snack time bersama' },
      { time: '09.45', activity: 'Bermain outdoor / musik' },
      { time: '10.15', activity: 'Bercerita & pulang' },
    ],
    facilities: ['Ruang bermain empuk', 'Toilet training area', 'Taman bermain aman', 'Alat sensorik lengkap'],
  },
  {
    id: 'tka',
    title: 'TK A',
    subtitle: 'Kindergarten A',
    age: 'Usia 4 Tahun',
    desc: 'Mengenal huruf, angka, cerita, dan seni melalui aktivitas yang menyenangkan setiap hari.',
    tags: ['#Membaca', '#Berhitung', '#Seni'],
    color: 'cream',
    tagline: 'Menjelajah dunia lewat huruf, angka, dan warna.',
    duration: '3 jam / hari',
    days: 'Senin - Jumat',
    ratio: '1 guru : 10 anak',
    price: 'Rp 550.000 / bulan',
    goals: [
      'Mengenal huruf A-Z dan angka 1-20 dengan menyenangkan',
      'Memahami konsep sederhana: banyak/sedikit, besar/kecil, urutan',
      'Mengekspresikan diri lewat gambar, cerita, dan lagu',
      'Belajar bekerja sama, mengantre, dan menyelesaikan tugas',
    ],
    subjects: [
      { icon: 'BookOpen', name: 'Pra-Membaca', desc: 'Kenal huruf, suku kata & cerita.' },
      { icon: 'Calculator', name: 'Pra-Berhitung', desc: 'Angka, jumlah & pola.' },
      { icon: 'Palette', name: 'Seni & Kreativitas', desc: 'Menggambar, melipat, mewarnai.' },
      { icon: 'Heart', name: 'Pendidikan Karakter', desc: 'Jujur, sopan & mandiri.' },
      { icon: 'Music', name: 'Musik & Gerak', desc: 'Nyanyi, tepuk irama, menari.' },
      { icon: 'Leaf', name: 'Sains Ceria', desc: 'Eksperimen sederhana & alam.' },
    ],
    schedule: [
      { time: '07.30', activity: 'Datang & baris pagi' },
      { time: '07.45', activity: 'Doa, salam & bernyanyi' },
      { time: '08.15', activity: 'Kegiatan inti sesuai tema' },
      { time: '09.15', activity: 'Snack & istirahat' },
      { time: '09.45', activity: 'Seni / musik / motorik' },
      { time: '10.30', activity: 'Bermain outdoor' },
      { time: '11.00', activity: 'Cerita, refleksi & pulang' },
    ],
    facilities: ['Kelas bertema', 'Perpustakaan mini', 'Studio seni', 'Playground'],
  },
  {
    id: 'tkb',
    title: 'TK B',
    subtitle: 'Kindergarten B',
    age: 'Usia 5 - 6 Tahun',
    desc: 'Persiapan menuju SD dengan menumbuhkan rasa ingin tahu, percaya diri dan mandiri.',
    tags: ['#Sains', '#Bahasa', '#Karakter'],
    color: 'sky',
    tagline: 'Siap terbang tinggi menuju sekolah dasar!',
    duration: '4 jam / hari',
    days: 'Senin - Jumat',
    ratio: '1 guru : 12 anak',
    price: 'Rp 650.000 / bulan',
    goals: [
      'Membaca kata sederhana & menulis nama sendiri',
      'Berhitung 1-100, penjumlahan & pengurangan dasar',
      'Berpikir kritis lewat eksperimen sains sederhana',
      'Percaya diri berbicara di depan kelas & memimpin doa',
    ],
    subjects: [
      { icon: 'BookOpen', name: 'Membaca & Menulis', desc: 'Kata, kalimat & bercerita.' },
      { icon: 'Calculator', name: 'Matematika Ceria', desc: 'Tambah, kurang, bentuk & pola.' },
      { icon: 'FlaskConical', name: 'Sains Eksperimen', desc: 'Air, magnet, tumbuhan.' },
      { icon: 'Globe', name: 'Bahasa Inggris', desc: 'Kosakata harian & lagu.' },
      { icon: 'Heart', name: 'Karakter & Agama', desc: 'Nilai baik & doa sehari-hari.' },
      { icon: 'Users', name: 'Kerja Kelompok', desc: 'Proyek mini bersama teman.' },
      { icon: 'Music', name: 'Seni Pertunjukan', desc: 'Drama, tari & musik.' },
      { icon: 'Dumbbell', name: 'Olahraga', desc: 'Senam, permainan & motorik.' },
    ],
    schedule: [
      { time: '07.30', activity: 'Datang & baris pagi' },
      { time: '07.45', activity: 'Doa, hafalan singkat & ikrar' },
      { time: '08.15', activity: 'Kegiatan inti (calistung / sains)' },
      { time: '09.30', activity: 'Snack & interaksi bebas' },
      { time: '10.00', activity: 'Bahasa Inggris / seni' },
      { time: '10.45', activity: 'Bermain outdoor / olahraga' },
      { time: '11.15', activity: 'Proyek kelompok / cerita' },
      { time: '11.45', activity: 'Refleksi, doa & pulang' },
    ],
    facilities: ['Kelas persiapan SD', 'Lab sains mini', 'Perpustakaan', 'Lapangan olahraga', 'Panggung mini'],
  },
];

export const galleryImages = [
  {
    src: 'https://images.unsplash.com/photo-1581861181562-34284733005a',
    title: 'Bermain Bersama',
    tags: '#Bermain #Persahabatan',
    place: 'Halaman Sekolah',
  },
  {
    src: 'https://images.pexels.com/photos/35107666/pexels-photo-35107666.jpeg',
    title: 'Melukis Ceria',
    tags: '#Seni #Kreativitas',
    place: 'Kelas Seni',
  },
  {
    src: 'https://images.pexels.com/photos/8422262/pexels-photo-8422262.jpeg',
    title: 'Belajar di Kelas',
    tags: '#Kelas #Belajar',
    place: 'Kelas TK A',
  },
  {
    src: 'https://images.unsplash.com/photo-1574704530833-d47190a0d92f',
    title: 'Kegiatan Luar',
    tags: '#Outdoor #Alam',
    place: 'Taman Bermain',
  },
  {
    src: 'https://images.pexels.com/photos/28232751/pexels-photo-28232751.jpeg',
    title: 'Bercerita',
    tags: '#Cerita #Bahasa',
    place: 'Perpustakaan Kecil',
  },
  {
    src: 'https://images.pexels.com/photos/8363053/pexels-photo-8363053.jpeg',
    title: 'Kerja Sama',
    tags: '#Tim #Bersama',
    place: 'Kelas TK B',
  },
  {
    src: 'https://images.unsplash.com/photo-1607211851821-8be3cd6146f0',
    title: 'Berkarya',
    tags: '#Seni #Warna',
    place: 'Kelas Seni',
  },
  {
    src: 'https://images.unsplash.com/photo-1613950190144-4f2a84c75e8c',
    title: 'Tangan Kecil',
    tags: '#Motorik #Halus',
    place: 'Meja Kreativitas',
  },
  {
    src: 'https://images.unsplash.com/photo-1560421683-6856ea585c78',
    title: 'Ekspresi Ceria',
    tags: '#Ekspresi #Bahagia',
    place: 'Ruang Kelas',
  },
];

export const teachers = [
  {
    name: 'Bu Ratna',
    role: 'Kepala Sekolah',
    line: 'Percaya bahwa setiap anak adalah bintang yang bersinar.',
    color: '#ffb3a0',
  },
  {
    name: 'Bu Nia',
    role: 'Wali Kelas TK A',
    line: 'Suka bercerita dongeng dan bernyanyi bersama anak-anak.',
    color: '#ffd76b',
  },
  {
    name: 'Bu Sari',
    role: 'Wali Kelas TK B',
    line: 'Senang mengajak anak menjelajah alam dan mengenal bentuk.',
    color: '#8ee0b7',
  },
  {
    name: 'Pak Iwan',
    role: 'Guru Olahraga',
    line: 'Mengajarkan permainan yang bikin badan sehat & hati senang.',
    color: '#9ec8ff',
  },
];

export const news = [
  {
    date: '2026.07.15',
    tag: 'Kegiatan',
    title: 'Puncak Tema "Kebunku" - Panen Sayur Bersama',
    img: 'https://images.pexels.com/photos/8363053/pexels-photo-8363053.jpeg',
  },
  {
    date: '2026.07.03',
    tag: 'Pengumuman',
    title: 'Pendaftaran Siswa Baru Tahun Ajaran 2026/2027 Dibuka',
    img: 'https://images.unsplash.com/photo-1607211851821-8be3cd6146f0',
  },
  {
    date: '2026.06.20',
    tag: 'Acara',
    title: 'Pentas Seni Akhir Tahun "Pelangi Melati"',
    img: 'https://images.pexels.com/photos/35107666/pexels-photo-35107666.jpeg',
  },
];

export const values = [
  { icon: 'Heart', title: 'Kasih Sayang', desc: 'Suasana hangat penuh kasih seperti di rumah sendiri.' },
  { icon: 'Sparkles', title: 'Kreatif', desc: 'Belajar dengan seni, musik, dan permainan yang seru.' },
  { icon: 'Leaf', title: 'Dekat Alam', desc: 'Kebun kecil dan halaman luas untuk bereksplorasi.' },
  { icon: 'Users', title: 'Bersama', desc: 'Bergandengan tangan dengan orang tua & guru.' },
];
